import { render, staticRenderFns } from "./EmailOpt.vue?vue&type=template&id=33124234&"
import script from "./EmailOpt.vue?vue&type=script&lang=js&"
export * from "./EmailOpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33124234')) {
      api.createRecord('33124234', component.options)
    } else {
      api.reload('33124234', component.options)
    }
    module.hot.accept("./EmailOpt.vue?vue&type=template&id=33124234&", function () {
      api.rerender('33124234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Privacy/EmailOpt.vue"
export default component.exports